//// Selected Vehicle
export const SET_VEHICLE_SELECTIONS = 'SET_VEHICLE_SELECTIONS';
// export const SET_SELECTED_VEHICLE_FMK = 'SET_SELECTED_VEHICLE_FMK';
// SET_SELECTED_YEAR
// SET_SELECTED_MAKE
// SET_SELECTED_MODEL
// SET_SELECTED_STYLE


//// Vehicle Options
export const POPULATE_YEAR_OPTIONS = 'POPULATE_YEAR_OPTIONS';
export const POPULATE_MAKE_OPTIONS = 'POPULATE_MAKE_OPTIONS';
export const POPULATE_MODEL_OPTIONS = 'POPULATE_MODEL_OPTIONS';
export const POPULATE_STYLE_OPTIONS = 'POPULATE_STYLE_OPTIONS';


export const mutations = {
    setSelectedVehicle: (state, vehicle) => state.selected = vehicle,
    setSelectedYear: (state, year) => state.selected.year = year,
    setSelectedMake: (state, make) => state.selected = make,
    setSelectedModel: (state, model) => state.selected = model,
    setSelectedStyle: (state, style) => state.selected = style,
    [SET_VEHICLE_SELECTIONS](state, selections) {
        let oldSelections = state.selections;
        // Clear out old fmk value, because it will be invalidated if selections change
        if (typeof oldSelections.fmk != 'undefined') delete oldSelections.fmk;
        
        state.selections = {...oldSelections, ...selections};
    },
    
    [POPULATE_YEAR_OPTIONS](state, years) {
        let oldOptions = state.options;
        state.options = {...oldOptions, years};
    },
    
    [POPULATE_MAKE_OPTIONS](state, makes) {
        let oldOptions = state.options;
        state.options = {...oldOptions, makes};
    },
    
    [POPULATE_MODEL_OPTIONS](state, models) {
        let oldOptions = state.options;
        state.options = {...oldOptions, models};
    },
    
    [POPULATE_STYLE_OPTIONS](state, styles) {
        let oldOptions = state.options;
        state.options = {...oldOptions, styles};
    },
};